import { memo } from 'react';
import { useDeleteChildSummaryMutation } from '@/services/child-api';
import { TrashSvg } from '@/assets/icons';
import Button from '@/components/button';
import Loading from '@/components/loading';

const SummaryRemover = ({ childId, summaryId, onRemove }) => {
  const [deleteSummary, { isLoading }] = useDeleteChildSummaryMutation();

  const onDeleteSummary = async () => {
    try {
      await deleteSummary({ childId, summaryId }).unwrap();
      onRemove();
    } catch (err) {}
  };

  return isLoading ? (
    <Loading size="small" />
  ) : (
    <Button type="link" onClick={onDeleteSummary}>
      <TrashSvg color="#ff4d4f" />
    </Button>
  );
};

export default memo(SummaryRemover);
